import type { LayoutType, TransitionType } from "@/lib/types";

export const LAYOUT_PRESETS: { v: LayoutType; label: string; zones: { id: string; label: string; x: number; y: number; w: number; h: number }[] }[] = [
  { v: "full", label: "Plein écran", zones: [{ id: "main", label: "Principale", x: 0, y: 0, w: 1, h: 1 }] },
  { v: "split_lr", label: "Moitié / moitié", zones: [{ id: "main", label: "Gauche", x: 0, y: 0, w: 0.5, h: 1 }, { id: "right", label: "Droite", x: 0.5, y: 0, w: 0.5, h: 1 }] },
  { v: "split_tb", label: "Haut / bas", zones: [{ id: "main", label: "Haut", x: 0, y: 0, w: 1, h: 0.5 }, { id: "bottom", label: "Bas", x: 0, y: 0.5, w: 1, h: 0.5 }] },
  { v: "main_right", label: "Principale + colonne", zones: [{ id: "main", label: "Principale", x: 0, y: 0, w: 0.7, h: 1 }, { id: "right", label: "Colonne droite", x: 0.7, y: 0, w: 0.3, h: 1 }] },
  { v: "main_bottom", label: "Principale + bande", zones: [{ id: "main", label: "Principale", x: 0, y: 0, w: 1, h: 0.75 }, { id: "bottom", label: "Bande du bas", x: 0, y: 0.75, w: 1, h: 0.25 }] },
  { v: "l_shape", label: "En L", zones: [{ id: "main", label: "Principale", x: 0, y: 0, w: 0.7, h: 0.75 }, { id: "right", label: "Colonne droite", x: 0.7, y: 0, w: 0.3, h: 1 }, { id: "bottom", label: "Bande du bas", x: 0, y: 0.75, w: 0.7, h: 0.25 }] },
  { v: "grid_4", label: "4 zones", zones: [{ id: "main", label: "Haut gauche", x: 0, y: 0, w: 0.5, h: 0.5 }, { id: "z2", label: "Haut droite", x: 0.5, y: 0, w: 0.5, h: 0.5 }, { id: "z3", label: "Bas gauche", x: 0, y: 0.5, w: 0.5, h: 0.5 }, { id: "z4", label: "Bas droite", x: 0.5, y: 0.5, w: 0.5, h: 0.5 }] },
];

export const TRANSITIONS: { v: TransitionType; label: string }[] = [
  { v: "none", label: "Aucune" },
  { v: "fade", label: "Fondu" },
  { v: "slide", label: "Glissement" },
  { v: "zoom", label: "Zoom" },
];

export const WALL_GRIDS: { cols: number; rows: number }[] = [
  { cols: 2, rows: 1 }, { cols: 3, rows: 1 }, { cols: 4, rows: 1 },
  { cols: 1, rows: 2 }, { cols: 1, rows: 3 }, { cols: 1, rows: 4 }, { cols: 2, rows: 2 },
];

export const ALERT_LEVELS = [
  { v: "danger", label: "Urgence", bg: "#DC2626", color: "#FFFFFF" },
  { v: "warning", label: "Avertissement", bg: "#F59E0B", color: "#111111" },
  { v: "info", label: "Information", bg: "#1D4ED8", color: "#FFFFFF" },
] as const;
